import { component } from 'picoapp';
import Swiper, { Autoplay } from 'swiper';

export default component((node) => {
  /**
   * Elements
   */
  const sliderElement = node.querySelector('.js-slider');
  const sliderWrapper = node.querySelector('.js-sliderWrapper');

  /**
   * Functions
   */
  const initSlider = () => {
    let slider;

    const reset = () => {
      if (slider?.destroy) {
        slider.destroy();
      }

      const isOverflowing = sliderElement.scrollWidth > sliderElement.getBoundingClientRect().width;

      sliderWrapper.classList[isOverflowing ? 'remove' : 'add']('justify-center');

      // TODO: Wait for https://github.com/nolimits4web/swiper/issues/5952 to get resolved.
      slider = new Swiper(sliderElement, {
        modules: [Autoplay],
        slidesPerView: 2.5,
        spaceBetween: 35,
        speed: 8000,
        loop: true,
        centeredSlides: true,
        loopPreventsSlide: true,
        loopAdditionalSlides: 100,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 75,
          },
        },
      });
    };

    reset();
    window.addEventListener('resize', reset);
  };

  const init = () => {
    initSlider();
  };

  init();
});
